import { useTransactionCertificateStore } from "../../../store/transaction-certificates.store";

export interface FacilityInformation {
  isMainSite: string;
  facilityNo: string;
  facilityType: string;
  facilityOARId: string;
  lastAuditDate: string;
  farmCapacity?: string[];
  farmNoAnimals?: string[];
  iId?: string;
  // brandNames?: string;
  facilityStandard?: string[];
  name: string;
  address1: string;
  address2?: string;
  address3?: string;
  postcode: string;
  town: string;
  countryArea: string;
  stateProvince?: string;
  subcontractorLicenseNo?: string;
  certificationBody: string;
  expiryDate: string;
}

export interface FacilityProcessDetails {
  FacilityProccessCategoryCode: string;
  FacilityProcessUserSpecificTerm: string;
}

export interface CompleteFacilityForm {
  facilityInformation: FacilityInformation;
}

export interface IfacilityDetailsReq {
  scId: string;
  facilityDetails: {
    isMainSite: string;
    facilityNo: string;
    facilityStandard: string[];
    facilityType: string;
    facilitySubcontractorLicenseNo: string;
    facilityOarId: string;
    facilityName: string;
    facilityTeId: string;
    facilityAddress1: string;
    facilityAddress2: string;
    facilityAddress3: string;
    facilityPostcode: string;
    facilityTown: string;
    facilityStateOrProvince: string;
    facilityCountryOrArea: string;
    facilityCbOfIndependentlyCertifiedSubcontractor: string;
    facilityExpiryDateOfIndependentlyCertifiedSubcontractor: string;
    facilityLastAuditDate: string;
    facilityFarmCapacity: string[];
    facilityFarmNoAnimals: string[];
    facilityProcessDetails: {
      facilityProcessCategoryCode: string;
      facilityProcessCategoryUserSpecificTerm: string;
    }[];
  }[];
}

export const initFacilityDetailsReq: IfacilityDetailsReq = {
  scId: '',
  facilityDetails: [{
    isMainSite: '',
    facilityNo: '',
    facilityStandard: [],
    facilityType: '',
    facilitySubcontractorLicenseNo: '',
    facilityOarId: '',
    facilityName: '',
    facilityTeId: '',
    facilityAddress1: '',
    facilityAddress2: '',
    facilityAddress3: '',
    facilityPostcode: '',
    facilityTown: '',
    facilityStateOrProvince: '',
    facilityCountryOrArea: '',
    facilityCbOfIndependentlyCertifiedSubcontractor: '',
    facilityExpiryDateOfIndependentlyCertifiedSubcontractor: '',
    facilityLastAuditDate: '',
    facilityFarmCapacity: [],
    facilityFarmNoAnimals: [],
    facilityProcessDetails: [{
      facilityProcessCategoryCode: '',
      facilityProcessCategoryUserSpecificTerm: '',
    }],
  }],
};

export const mapToFacilityDetailsReq = (
  data: any,
  SC_ID: string,
  facilityId?: string|null,
  isPostCreation?: string,
): any => {
  // If data is not an array, wrap it into one
  // alert("23---"+facilityId)
  const facilities = Array.isArray(data) ? data : [data];
  const facilityTypeOptions = [
    { value: 'MF', label: 'Main Facility/Main Site' },
    { value: 'FA', label: 'Facility/Subsequent Site' },
    { value: 'AS', label: 'Associated Subcontractor' },
    { value: 'CS', label: 'Independently Certified Subcontractor' }
  ]
  const facilityStandardCodesOptions = [
    { label: "Organic Content Standard", value: "OCS" }, // Represents "Valid"
    { label: "Global Recycled Standard", value: "GRS" }, // Represents "Expired" 
    { label: "Recycled Claim Standard", value: "RCS" }, // Represents "Suspended"
    { label: "Responsible Down Standard", value: "RDS" }, // Represents "Withdrawn"
    { label: "Responsible Wool Standard", value: "RWS" }, // Represents "Withdrawn"
    { label: "Responsible Mohair Standard", value: "RMS" }, // Represents "Withdrawn"
    { label: "Responsible Alpaca Standard", value: "RAS" }, // Represents "Withdrawn"
    { label: "Content Claim Standard", value: "CCS" }, // Represents "Withdrawn"
    { label: "SFA", value: "SFA" }, // Represents "Withdrawn"
    { label: "Global Organic Textile Standard", value: "GOTS" }, // Represents "Withdrawn"
  ];
  return {
    scId: SC_ID,
    ...(facilityId && { facilityId }),
    facilityDetails: facilities.map((facility) => ({
      isMainSite: facility.facilityInfo?.facilityType === 'MF' ? 'Y' : 'N',
      facilityNo: facility.facilityInfo?.facilityNo || '',
      facilityStandard: facility.facilityInfo?.facilityStandard || [],
      facilityStandardDescription: facilityStandardCodesOptions
      .filter(option => facility.facilityInfo.facilityStandard.includes(option.value))
      .map(option => option.label.trim()) || [],
      facilityType: facility.facilityInfo?.facilityType || '',
      facilityTypeDescription: facilityTypeOptions.find((option: any) => option.value === (facility.facilityInfo.facilityType ?? ""))?.label.trim() ?? "",
      facilitySubcontractorLicenseNo: facility.facilityInfo?.subcontractorLicenseNo || '',
      facilityOarId: facility.facilityInfo?.facilityOARId || '',
      facilityName: facility.facilityInfo?.name || '',
      facilityTeId: facility.facilityInfo?.iId || '',
      facilityAddress1: facility.facilityInfo?.address1 || '',
      facilityAddress2: facility.facilityInfo?.address2 || '',
      facilityAddress3: facility.facilityInfo?.address3 || '',
      facilityPostcode: facility.facilityInfo?.postcode || '',
      facilityTown: facility.facilityInfo?.town || '',
      facilityStateOrProvince: facility.facilityInfo?.stateProvince || '',
      facilityStateOrProvinceDescription: useTransactionCertificateStore.getState().getStates.find((option: any) => option.value === (facility.facilityInfo.stateProvince ?? ""))?.label.trim() ?? "",
      facilityCountryOrArea: facility.facilityInfo?.countryArea || '',
      facilityCountryOrAreaDescription: useTransactionCertificateStore.getState().getCountries.find((option: any) => option.value === (facility.facilityInfo.countryArea ?? ""))?.label.trim() ?? "",

      facilityCbOfIndependentlyCertifiedSubcontractor: facility.facilityInfo?.certificationBody || '',
      facilityExpiryDateOfIndependentlyCertifiedSubcontractor: facility.facilityInfo?.expiryDate || '',
      facilityCbOfIndependentlyCertifiedSubcontractorDescription: useTransactionCertificateStore.getState().getCBLicensingsCodes.find((option: any) => option.value === (facility.facilityInfo.certificationBody ?? ""))?.label.trim() ?? "",
      facilityLastAuditDate: facility.facilityInfo?.lastAuditDate || '',
      facilityFarmCapacity: facility.facilityInfo?.farmCapacity || [],
      facilityFarmNoAnimals: facility.facilityInfo?.farmNoAnimals || [],
      isPostCreation: isPostCreation || "yes",
      facilityProcessDetails: facility.facilityProcessDetails?.map((process: any) => ({
        facilityProcessCategoryCode: process.FacilityProccessCategoryCode || '',
        facilityProcessCategoryCodeDescription:useTransactionCertificateStore.getState().getFacilityProcessCategoryCodes.find((option: any) => option.value === (process.FacilityProccessCategoryCode ?? ""))?.label.trim() ?? "",
        facilityProcessCategoryUserSpecificTerm: process.FacilityProcessUserSpecificTerm || '',
        actions: process.actions || '',
        additionalProp1: process.additionalProp1 || {}
      })) || [],
      additionalProp1: facility.facilityInfo?.additionalProp1 || {}
    })),
    additionalProp1: {}
  };
};


export const mapToFacilityDetailsDeteleSaveReq = (data: any[], SC_ID: string, postCreation?: string): IfacilityDetailsReq => {
  return {
    scId: SC_ID,
    facilityDetails: data.map(facility => ({
      isMainSite: facility.facilityInfo?.facilityType === 'MF' ? 'Y' : 'N',
      facilityNo: facility.facilityNo || '',
      facilityStandard: facility.facilityStandard || [],
      facilityType: facility.facilityType || '',
      facilitySubcontractorLicenseNo: facility.subcontractorLicenseNo || '',
      facilityOarId: facility.facilityOARId || '',
      facilityName: facility.name || '',
      facilityTeId: facility.iId || '',
      facilityAddress1: facility.address1 || '',
      facilityAddress2: facility.address2 || '',
      facilityAddress3: facility.address3 || '',
      facilityPostcode: facility.postcode || '',
      facilityTown: facility.town || '',
      facilityStateOrProvince: facility.stateProvince || '',
      facilityCountryOrArea: facility.countryArea || '',
      facilityCbOfIndependentlyCertifiedSubcontractor: facility.certificationBody || '',
      facilityExpiryDateOfIndependentlyCertifiedSubcontractor: facility.expiryDate || '',
      facilityLastAuditDate: facility.lastAuditDate || '',
      facilityFarmCapacity: facility.farmCapacity || [],
      facilityFarmNoAnimals: facility.farmNoAnimals || [],
      isPostCreaction: postCreation || "no",
      facilityProcessDetails: facility.facilityProcessDetails.map((process: any) => ({
        facilityProcessCategoryCode: process.FacilityProccessCategoryCode || '',
        facilityProcessCategoryUserSpecificTerm: process.FacilityProcessUserSpecificTerm || '',
        actions: '',
      })),
    })),
  };
};
export interface FacilityInformation {
  isMainSite: string;
  facilityNo: string;
  facilityType: string;
  facilityOARId: string;
  lastAuditDate: string;
  farmCapacity?: string[];
  farmNoAnimals?: string[];
  iId?: string;
  facilityStandard?: string[];
  name: string;
  address1: string;
  address2?: string;
  address3?: string;
  postcode: string;
  town: string;
  countryArea: string;
  stateProvince?: string;
  subcontractorLicenseNo?: string;
  certificationBody: string;
  expiryDate: string;
}

export interface FacilityProcessDetails {
  FacilityProccessCategoryCode: string;
  FacilityProcessUserSpecificTerm: string;
}

export interface FacilityState {
  facilityInfo: FacilityInformation;
  facilityProcessDetails: FacilityProcessDetails[];
}

type InputData = {
  scId: string;
  facilityDetails: {
    isMainSite: string;
    facilityNo: string;
    facilityType: string;
    facilityOarId: string;
    facilityLastAuditDate: string;
    facilityFarmCapacity?: string[];
    facilityFarmNoAnimals?: string[];
    facilityTeId?: string;
    facilityStandard?: string[];
    facilityName: string;
    facilityAddress1: string;
    facilityAddress2?: string;
    facilityAddress3?: string;
    facilityPostcode: string;
    facilityTown: string;
    facilityCountryOrArea: string;
    facilityStateOrProvince?: string;
    facilitySubcontractorLicenseNo?: string;
    facilityCbOfIndependentlyCertifiedSubcontractor: string;
    facilityExpiryDateOfIndependentlyCertifiedSubcontractor: string;
    facilityProcessDetails: {
      facilityProcessCategoryCode: string;
      facilityProcessCategoryUserSpecificTerm: string;
    }[];
  }[];
};

export const mapFacilityDetails = (facilityDetails: any[]): any[] => {
  if (!Array.isArray(facilityDetails)) {
    throw new Error("Invalid facility details: Expected an array");
  }

  return facilityDetails.map((facility, index) => {
    // Validate required fields
    if (!facility.facilityNo || !facility.facilityName) {
      throw new Error(`Missing required fields in facility at index ${index}`);
    }

    return {
      facilityInfo: {
        facilityId: facility.facilityId || "",
        facilityNo: facility.facilityNo,
        facilityType:facility.facilityType,
        facilityOARId: facility.facilityOarId ?? "",
        lastAuditDate: facility.facilityLastAuditDate ?? "",
        name: facility.facilityName,
        postcode: facility.facilityPostcode ?? "",
        countryArea: facility.facilityCountryOrArea ?? "",
        certificationBody: facility.facilityCbOfIndependentlyCertifiedSubcontractor ?? "",
        expiryDate: facility.facilityExpiryDateOfIndependentlyCertifiedSubcontractor ?? "",
      },
      facilityProcessDetails: [],
    };
  });
};

